import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { LogoutNotice } from '../common/LogoutNotice.js';
import { SubscriptionExpiredDialog } from '../common/SubscriptionExpiredDialog.js';
import { TosPrompt } from '../common/TosPrompt.js';
import { DeveloperErrorDialog } from './DeveloperErrorDialog.js';
import { ResetNotifier } from './ResetNotifier.js';
export function Essentials() {
    useEffect(() => {
        if (typeof document === 'undefined')
            return;
        document.body.style.setProperty('overscroll-behavior', 'none');
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(LogoutNotice, {}), _jsx(TosPrompt, {}), _jsx(SubscriptionExpiredDialog, {}), _jsx(ResetNotifier, {}), _jsx(DeveloperErrorDialog, {})] }));
}
//# sourceMappingURL=Essentials.js.map